import posthog from 'posthog-js';

class PosthogTracker {
  private capture = (event: string, properties?: Record<string, any>) => {
    posthog?.capture(event, properties);
  };

  identify = (phoneNumber: string) => {
    posthog?.identify(phoneNumber);
  };

  captureViewItemList() {
    this.capture('view_item_list');
  }

  capturePurchase({ price, specialityLabel }: { price: number; specialityLabel: string }) {
    this.capture('purchase', { currency: 'EUR', price, specialityLabel });
  }

  captureAddToCart() {
    this.capture('add_to_cart');
  }

  captureConfirmTimeSelection() {
    this.capture('confirm_time_selection');
  }

  captureWhatsappClick() {
    this.capture('click_card_whatsapp');
  }

  capturePhoneClick() {
    this.capture('click_card_telefono');
  }

  captureMobilePhoneClick() {
    this.capture('click_card_telefono_only');
  }
}

export const posthogTracker = new PosthogTracker();
